import { render, staticRenderFns } from "./AllClients.vue?vue&type=template&id=1940170b&"
import script from "./AllClients.vue?vue&type=script&lang=js&"
export * from "./AllClients.vue?vue&type=script&lang=js&"
import style0 from "./AllClients.vue?vue&type=style&index=0&id=1940170b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports